"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactAutobind = _interopRequireDefault(require("react-autobind"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _spacing = _interopRequireDefault(require("../../constants/spacing"));

var _vars = _interopRequireDefault(require("../../constants/vars"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _H = _interopRequireDefault(require("../Typography/H2"));

var _P = _interopRequireDefault(require("../Typography/P"));

var _OutlineButton = _interopRequireDefault(require("../Button/OutlineButton"));

var _Modal = _interopRequireDefault(require("../Modal"));

var _ModalBody = _interopRequireDefault(require("../Modal/ModalBody"));

var _Alert = _interopRequireDefault(require("../Alert"));

var _Error = _interopRequireDefault(require("../Icons/Error"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\ttext-align: center;\n\tpadding: ", ";\n\n\t", " {\n\t\tmargin-bottom: ", ";\n\t}\n\n\t> ", " {\n\t\tmargin-bottom: ", ";\n\t}\n\n\t", " {\n\t\tmargin-right: ", ";\n\t}\n\n\t", " {\n\t\ttext-align: left;\n\t\tmargin-bottom: ", ";\n\t\tfont-weight: bold;\n\t\tfont-family: ", ";\n\t}\n\n\t.error-icon {\n\t\tmargin-right: ", ";\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Container = (0, _styledComponents.default)(_ModalBody.default)(_templateObject(), _spacing.default.s5, _H.default, _spacing.default.s2, _P.default, _spacing.default.s4, _Button.default, _spacing.default.s2, _Alert.default, _spacing.default.s2, _vars.default.fontStackBold, _spacing.default.s1);
Container.displayName = 'Container';

var withConfirmation = function withConfirmation(WrappedComponent) {
  var Confirmation =
  /*#__PURE__*/
  function (_React$Component) {
    _inheritsLoose(Confirmation, _React$Component);

    function Confirmation(props) {
      var _this;

      _this = _React$Component.call(this, props) || this;
      _this.state = {
        error: null,
        loading: false,
        open: false
      };
      (0, _reactAutobind.default)(_assertThisInitialized(_this));
      return _this;
    }

    var _proto = Confirmation.prototype;

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.setState({
        open: false
      });
    };

    _proto.onButtonClick = function onButtonClick(e) {
      var _this2 = this;

      e.preventDefault();
      this.setState({
        loading: true,
        error: false
      });
      Promise.resolve(this.props.onClick()).then(this.close).catch(function (err) {
        return _this2.setState({
          error: err.message,
          loading: false
        });
      });
    };

    _proto.open = function open(e) {
      e.preventDefault();
      this.setState({
        open: true
      });
    };

    _proto.close = function close() {
      this.setState({
        open: false,
        error: null,
        loading: false
      });
    };

    _proto.render = function render() {
      var _this$props = this.props,
          children = _this$props.children,
          onClick = _this$props.onClick,
          href = _this$props.href,
          message = _this$props.message,
          yesLabel = _this$props.yesLabel,
          noLabel = _this$props.noLabel,
          title = _this$props.title,
          buttonProps = _this$props.buttonProps,
          props = _objectWithoutPropertiesLoose(_this$props, ["children", "onClick", "href", "message", "yesLabel", "noLabel", "title", "buttonProps"]);

      var _this$state = this.state,
          open = _this$state.open,
          loading = _this$state.loading,
          error = _this$state.error;
      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(WrappedComponent, _extends({}, props, {
        onClick: this.open
      }), children), open && _react.default.createElement(_Modal.default, {
        version: "2",
        close: this.close
      }, _react.default.createElement(Container, null, _react.default.createElement(_H.default, null, title), message && _react.default.createElement(_P.default, null, message), error && _react.default.createElement(_Alert.default, {
        type: "warning"
      }, _react.default.createElement(_P.default, null, _react.default.createElement(_Error.default, {
        className: "error-icon",
        size: 16,
        color: "#fff"
      }), ' ', error)), _react.default.createElement(_Button.default, _extends({}, buttonProps, {
        loading: loading,
        disabled: loading,
        onClick: !href ? this.onButtonClick : this.close,
        href: href || undefined,
        as: href ? 'a' : 'button'
      }), error ? 'Try again' : yesLabel), _react.default.createElement(_OutlineButton.default, {
        onClick: this.close
      }, error ? 'Cancel' : noLabel))));
    };

    return Confirmation;
  }(_react.default.Component);

  Confirmation.propTypes = {
    onClick: _propTypes.func,
    children: _propTypes.node.isRequired,
    yesLabel: _propTypes.string,
    noLabel: _propTypes.string,
    message: _propTypes.string,
    href: _propTypes.string,
    title: _propTypes.string,
    // eslint-disable-next-line react/forbid-prop-types
    buttonProps: _propTypes.object
  };
  Confirmation.defaultProps = {
    onClick: null,
    message: '',
    href: null,
    title: 'Are you sure?',
    buttonProps: {},
    yesLabel: 'Yes',
    noLabel: 'No'
  };
  return Confirmation;
};
/* @component */


var _default = withConfirmation;
exports.default = _default;